export function getLocaleValue<T extends Record<string, unknown>, K extends string>(
  content: T | undefined,
  value: K,
  lang: string // "fi" | "en"
): string | null {
  if (!content) {
    return null
  }

  const keyWithLang = `${value}${lang.charAt(0).toUpperCase()}${lang.slice(1)}`
  const result = content[keyWithLang as keyof T] ?? content[value as keyof T]

  return typeof result === "string" ? result : null
}
